import { mapState, mapActions } from "vuex";
import Common from "@/libs/Common.js";

export default {
  name: "ExcelManagePopup",
  props: {
    isVisible: {
      type: Boolean,
    },
    editTemplate: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      // 선택된 템플릿
      selectedTemplate: "",
      
      // 템플릿 이름
      templateName: "",
      isPresetSelected: false,
      
      // 검색어
      searchAvailable: "",
      searchSelected: "",
      orderBy: "",
      
      // 기존 템플릿 목록 (Mock 데이터에서 동적 로드)
      existingTemplates: [],
      
      // 다운로드 설정한 항목
      downloadItems: [],
      
      // 선택된 항목들
      selectedAvailableItems: [],
      selectedDownloadItems: [],
      saveText: "저장",
      
      // 원본 데이터 (초기화용)
      originalData: {
        templateName: "",
        downloadItems: [],
        isPresetSelected: false
      }
    };
  },
  created: function(){
    this.loadExistingTemplates();
  },
  computed: {
    ...mapState("common", ["mall_id", "real_mall_id"]),
    
    currentMallId() {
      return this.real_mall_id || this.mall_id;
    },
    
    // 다운로드 가능한 항목 (Common.js에서 가져오기)
    availableItems() {
      return Common.getExcelTemplateColumns();
    },
    
    // 검색된 사용 가능한 항목들 (이미 선택된 항목 제외)
    filteredAvailableItems() {
      let availableItems = this.availableItems.filter(item => 
        !this.downloadItems.find(d => d.key === item.key)
      );
      
      
      // 정렬 적용
      if (this.orderBy) {
        availableItems = availableItems.sort((a, b) => {
          if (this.orderBy === 'asc') {
            return a.name.localeCompare(b.name, 'ko', { numeric: true });
          } else if (this.orderBy === 'desc') {
            return b.name.localeCompare(a.name, 'ko', { numeric: true });
          }
          return 0;
        });
      }
      
      return availableItems;
    },
    
    // 검색된 선택된 항목들
    filteredDownloadItems() {
      let downloadItems = this.downloadItems;
      return downloadItems;
    },
    
    // 템플릿 이름 비활성화 여부 (프리셋인 경우 비활성화)
    isTemplateNameDisabled() {
      return this.isPresetSelected || (this.selectedTemplate && this.selectedTemplate !== "");
    }
  },
  
  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.initializeForm();
      }
    },
    
    selectedTemplate(newVal) {
      if (newVal) {
        this.loadTemplateData(newVal);
      } else {
        this.resetForm();
      }
    }
  },
  
  _methods: {
    ...mapActions("supply", [
      "getCustomExcelTemplates",
      "getCustomExcelTemplateDetail",
      "createCustomExcelTemplate",
      "updateCustomExcelTemplate"
    ]),

    // 기존 템플릿 목록 로드 (API에서)
    async loadExistingTemplates() {
      try {
        const response = await this.getCustomExcelTemplates({ type: 'all', order: 'preset_desc' });
        this.existingTemplates = response.list;
        console.log("📋 기존 템플릿 로드 완료:", this.existingTemplates.length);
      } catch (error) {
        console.error("기존 템플릿 로드 실패:", error);
        this.existingTemplates = [];
      }
    },

    // 폼 초기화
    async initializeForm() {
      if (this.editTemplate) {
        console.log("편집할 템플릿 로드:", this.editTemplate);

        // editTemplate에 custom_setting_id가 있는 경우 해당 템플릿을 select에서 선택
        if (this.editTemplate.custom_setting_id) {
          this.selectedTemplate = this.editTemplate.custom_setting_id;
        }

        await this.loadTemplateData(this.editTemplate.custom_setting_id);
      } else {
        this.resetForm();
        // 새 양식의 경우 빈 상태를 원본으로 설정
        this.originalData = {
          templateName: "",
          downloadItems: [],
          isPresetSelected: false
        };
      }
    },
    // 템플릿 데이터 로드
    async loadTemplateData(key_id) {
      const response = await this.getCustomExcelTemplateDetail(key_id);
      console.log("detail - ", response, response.setting_name);
      if (response) {
        // 프리셋 템플릿 객체 로드
        this.templateName = response.setting_name || "";
        this.isPresetSelected = response.is_preset;
        // 커스텀 템플릿 로드
        if (Array.isArray(response.column_settings) && typeof response.column_settings[0] === 'string') {
          // column_settings가 string 배열인 경우
          let blank_index = 0;
          this.downloadItems = response.column_settings.map(key => {
            const availableItem = this.availableItems.find(item => item.key === key);
            // key가 비어있으면 blank_column으로 처리
            if (key === '') {

              const blankColumnCount = blank_index;
              blank_index++;
              return {
                key: `blank_column_${blankColumnCount + 1}`,
                name: '-'
              };
            } else {
              return {
                key: key,
                name: availableItem ? availableItem.name : key
              };
            }
          });
          console.log("다운로드 항목 로드:", this.downloadItems);
        } else {
          // column_settings가 객체 배열인 경우
          this.downloadItems = response.column_settings.map(col => ({
            key: col.key,
            name: col.displayName || col.name || col.key
          }));
        }
        this.saveText = "수정";

        // 원본 데이터 저장 (Deep copy)
        this.originalData = {
          templateName: this.templateName,
          downloadItems: JSON.parse(JSON.stringify(this.downloadItems)),
          isPresetSelected: this.isPresetSelected
        };
      }
    },
    onTemplateChange() {
      console.log("template select change");
      this.templateName = "";
    },

    // 사용 가능한 항목 검색 버튼 클릭
    searchAbleItems() {
      let availableItems = this.availableItems.filter(item => !this.downloadItems.find(d => d.key === item.key)
      );
      if (this.searchAvailable) {
        const searchTerm = this.searchAvailable.toLowerCase();
        const matchedItems = availableItems.filter(item => item.name.toLowerCase().includes(searchTerm)
        );

        // 검색된 항목들만 선택 상태로 설정 (기존 선택 항목 대체)
        const matchedKeys = matchedItems.map(item => item.key);
        if (matchedKeys.length > 0) {
          this.selectedAvailableItems = matchedKeys;
        } else {
          this.selectedAvailableItems = [];
        }
      }
    },

    // 선택된 항목 검색 버튼 클릭
    searchSelectItems() {
      let downloadItems = this.downloadItems;

      // 검색어가 있을 때 해당 항목들만 자동 선택 (필터링하지 않고 모든 항목 표시)
      if (this.searchSelected) {
        const searchTerm = this.searchSelected.toLowerCase();
        const matchedItems = downloadItems.filter(item => item.name.toLowerCase().includes(searchTerm)
        );

        // 검색된 항목들만 선택 상태로 설정 (기존 선택 항목 대체)
        const matchedKeys = matchedItems.map(item => item.key);
        if (matchedKeys.length > 0) {
          this.selectedDownloadItems = matchedKeys;
        } else {
          this.selectedDownloadItems = [];
        }
      }
    },
    clickResetForm() {
      if (confirm("초기화 하시겠습니까?")) {
        if (this.selectedTemplate && this.selectedTemplate !== "") {
          // 선택한 양식이 있는 경우: 변경전 상태로 복원
          this.restoreOriginalData();
        } else {
          // 새로운 양식인 경우: 완전 초기화
          this.resetForm();
        }
      }
    },

    // 원본 데이터로 복원하는 메서드
    restoreOriginalData() {
      this.templateName = this.originalData.templateName;
      this.downloadItems = JSON.parse(JSON.stringify(this.originalData.downloadItems));
      this.isPresetSelected = this.originalData.isPresetSelected;

      // 검색어와 선택 상태 초기화
      this.searchAvailable = "";
      this.searchSelected = "";
      this.selectedAvailableItems = [];
      this.selectedDownloadItems = [];
    },
    // 폼 리셋
    resetForm() {
      this.selectedTemplate = "";
      this.templateName = "";
      this.isPresetSelected = false;
      this.searchAvailable = "";
      this.searchSelected = "";
      this.downloadItems = [];
      this.selectedAvailableItems = [];
      this.selectedDownloadItems = [];
      this.saveText = "저장";
    },
    // 오른쪽으로 이동 (추가)
    moveRight() {
      if (this.selectedAvailableItems.length === 0) {
        alert("추가할 항목을 선택해주세요.");
        return;
      }

      // 선택된 항목들을 downloadItems에 추가
      this.selectedAvailableItems.forEach(itemKey => {
        const item = this.availableItems.find(i => i.key === itemKey);
        if (item) {
          // 이미 downloadItems에 있는지 다시 한번 확인 (중복 방지)
          if (!this.downloadItems.find(d => d.key === item.key)) {
            this.downloadItems.push({ ...item });
          }
        }
      });

      // 선택 상태 초기화
      this.selectedAvailableItems = [];
    },

    // 왼쪽으로 이동 (제거)
    moveLeft() {
      if (this.selectedDownloadItems.length === 0) {
        alert("제거할 항목을 선택해주세요.");
        return;
      }

      this.downloadItems = this.downloadItems.filter(item => !this.selectedDownloadItems.includes(item.key)
      );

      this.selectedDownloadItems = [];
    },

    // 전체 추가 (이미 선택된 항목 제외)
    addAllItems() {
      const availableToAdd = this.availableItems.filter(item => !this.downloadItems.find(d => d.key === item.key)
      );

      availableToAdd.forEach(item => {
        this.downloadItems.push({ ...item });
      });

      this.selectedAvailableItems = [];
    },

    // 전체 삭제
    removeAllItems() {
      this.downloadItems = [];
      this.selectedDownloadItems = [];
    },

    // 빈 컬럼 추가
    addBlankColumn() {
      const blankColumnCount = this.downloadItems.filter(item => item.key.startsWith('blank_column_')
      ).length;

      const newBlankColumn = {
        key: `blank_column_${blankColumnCount + 1}`,
        name: `-`
      };

      this.downloadItems.push(newBlankColumn);
    },

    // 위로 이동
    moveUp() {
      if (this.selectedDownloadItems.length === 0) {
        alert("이동할 항목을 선택해주세요.");
        return;
      }

      // 현재 선택된 항목들의 키를 저장
      const selectedKeys = [...this.selectedDownloadItems];

      const selectedIndexes = selectedKeys.map(itemKey => this.downloadItems.findIndex(item => item.key === itemKey)
      ).sort((a, b) => a - b);

      // 선택된 항목들을 위로 이동
      selectedIndexes.forEach(index => {
        if (index > 0) {
          const temp = this.downloadItems[index];
          this.$set(this.downloadItems, index, this.downloadItems[index - 1]);
          this.$set(this.downloadItems, index - 1, temp);
        }
      });

      // Vue의 reactivity 시스템을 위해 nextTick에서 선택 상태 복원
      this.$nextTick(() => {
        this.selectedDownloadItems = selectedKeys;
      });
    },

    // 아래로 이동
    moveDown() {
      if (this.selectedDownloadItems.length === 0) {
        alert("이동할 항목을 선택해주세요.");
        return;
      }

      // 현재 선택된 항목들의 키를 저장
      const selectedKeys = [...this.selectedDownloadItems];

      const selectedIndexes = selectedKeys.map(itemKey => this.downloadItems.findIndex(item => item.key === itemKey)
      ).sort((a, b) => b - a);

      // 선택된 항목들을 아래로 이동
      selectedIndexes.forEach(index => {
        if (index < this.downloadItems.length - 1) {
          const temp = this.downloadItems[index];
          this.$set(this.downloadItems, index, this.downloadItems[index + 1]);
          this.$set(this.downloadItems, index + 1, temp);
        }
      });

      // Vue의 reactivity 시스템을 위해 nextTick에서 선택 상태 복원
      this.$nextTick(() => {
        this.selectedDownloadItems = selectedKeys;
      });
    },

    // 템플릿 저장
    async saveTemplate() {
      if (this.downloadItems.length === 0) {
        alert("최소 1개 이상의 항목을 선택해주세요.");
        return;
      }

      if (!this.templateName.trim()) {
        alert("템플릿 이름을 입력해주세요.");
        return;
      } else {
        // 쳌
        // 템플릿 이름 중복 체크
        const existingNames = this.existingTemplates.map(template => template.setting_name);
        const isEdit = !!this.selectedTemplate; // 수정모드인지 확인
        const currentTemplate = isEdit ? this.existingTemplates.find(t => t.custom_setting_id === this.selectedTemplate) : null;

        // 수정 모드에서 이름이 변경되지 않은 경우는 중복 체크 하지 않음
        if (isEdit && currentTemplate && currentTemplate.setting_name === this.templateName.trim()) {
          // 이름이 변경되지 않았으므로 중복 체크 패스
        } else if (existingNames.includes(this.templateName.trim())) {
          alert("이미 사용중인 템플릿 이름입니다. 다른 이름을 입력해주세요.");
          return;
        }
      }

      try {
        const templateData = {
          setting_name: this.templateName.trim(),
          column_settings: this.downloadItems.map(item => (
            item.key.startsWith('blank_column_') ? '' : item.key
          )),
        };

        console.log("템플릿 데이터:", templateData);
        if (this.selectedTemplate) {
          templateData.custom_setting_id = this.selectedTemplate;
          await this.updateCustomExcelTemplate({
            customSettingId: this.selectedTemplate,
            params: templateData
          });
          alert("엑셀 양식이 수정되었습니다.");
        } else {
          await this.createCustomExcelTemplate(
            templateData
          );
          alert("엑셀 양식이 저장되었습니다.");
        }

        this.closeModal();
        this.$emit("saved", templateData);

      } catch (error) {
        console.error("템플릿 저장 실패:", error);
        alert("엑셀 양식 저장에 실패했습니다.");
      } finally {
        this.loadExistingTemplates();
      }
    },

    // 모달 닫기
    closeModal() {
      this.$emit("close");
      this.resetForm();
    }
  },
  get methods() {
    return this._methods;
  },
  set methods(value) {
    this._methods = value;
  },
};
